import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
    Snackbar,
    Box,
    Button,
    Card,
    Toolbar,
    Typography,
    Container,
    Paper,
    AppBar,
    Tabs,
    Tab,
    Checkbox,
    FormControlLabel,
    Divider
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import axios from 'axios';
import withErrorHandler from "app/hoc/withErrorHandler/withErrorHandler";

import clsx from "clsx";

import sctregLogo from '../../../views/sessions/login/sctregLogo.png';
import { deepUpdateState } from "app/c1utils/stateUtils";
import RegisterDocs from "./RegisterDocs";
import C1Alert from "app/c1component/C1Alert";
import useHttp from "app/c1hooks/http";
import TraderDetail from "./TraderDetail";
import UserDetail from "./UserDetail";

const useStyles = makeStyles(({ palette, ...theme }) => ({
    page: {
        minHeight: '100vh',
        backgroundColor: '#f5f7fb',
        display: 'flex',
        flexDirection: 'column',
    },
    topBar: {
        backgroundColor: '#3C77D0',
        borderBottom: '1px solid transparent',
        paddingTop: '0.9rem',
        paddingBottom: '0.9rem',
        paddingLeft: '1.25rem',
        paddingRight: '1.25rem',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '0.75rem',
            paddingRight: '0.75rem',
        },
    },
    brandText: {
        color: palette.primary.contrastText,
        fontWeight: 600,
    },
    main: {
        width: '100%',
        flex: 1,
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(4),
    },
    formShell: {
        width: '60%',
        minWidth: 320,
        maxWidth: 980,
        margin: '0 auto',
        [theme.breakpoints.down('md')]: {
            width: '78%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '94%',
        },
    },
    hero: {
        backgroundColor: '#3C77D0',
        color: '#fff',
        borderTopLeftRadius: 28,
        borderTopRightRadius: 28,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        padding: theme.spacing(2, 5),
        marginBottom: theme.spacing(0),
        boxShadow: '0 20px 40px rgba(34, 64, 135, 0.14)',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(3, 2.5),
            borderTopLeftRadius: 22,
            borderTopRightRadius: 22,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },
    },
    heroTitle: {
        fontWeight: 700,
        lineHeight: 1.15,
        marginBottom: theme.spacing(1),
        textAlign: 'center',
    },
    heroSubTitle: {
        opacity: 0.96,
        textAlign: 'justify',
        fontWeight: 400,
        lineHeight: 1.3,
        letterSpacing: '-0.01em',
    },
    tabsCard: {
        borderRadius: 0,
        border: '1px solid #e3e8f2',
        borderTop: 'none',
        boxShadow: 'none',
        overflow: 'hidden',
    },
    tabsRoot: {
        backgroundColor: '#fff',
    },
    sectionCard: {
        borderRadius: 0,
        border: '1px solid #e3e8f2',
        borderTop: 'none',
        boxShadow: 'none',
        overflow: 'hidden',
    },
    sectionInner: {
        padding: theme.spacing(2.5, 3.5, 3),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, 1.5, 2.5),
        },
    },
    sectionEyebrow: {
        color: '#6b7a99',
        fontSize: '0.8rem',
        fontWeight: 700,
        letterSpacing: '0.16em',
        textTransform: 'uppercase',
        marginBottom: theme.spacing(0.75),
    },
    sectionTitle: {
        color: '#1f2a44',
        fontWeight: 700,
        marginBottom: theme.spacing(0.75),
    },
    sectionDescription: {
        color: '#7181a1',
        marginBottom: theme.spacing(2.25),
        maxWidth: 760,
    },
    actionsCard: {
        border: '1px solid #e3e8f2',
        borderTop: 'none',
        borderRadius: '0 0 22px 22px',
        boxShadow: 'none',
        backgroundColor: '#fff',
    },
    actionsInner: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: theme.spacing(2),
        padding: theme.spacing(2, 3.5),
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'stretch',
            padding: theme.spacing(2, 1.5),
        },
    },
    actionsHint: {
        color: '#6b7a99',
    },
    navButton: {
        minWidth: 148,
        borderRadius: 14,
        padding: theme.spacing(1.25, 3),
        backgroundColor: '#3C77D0',
        color: '#fff',
        fontWeight: 700,
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#2f64b4',
            boxShadow: 'none',
        },
        '&.Mui-disabled': {
            backgroundColor: '#c7d7f3',
            color: '#ffffff',
        },
    },
    submitButton: {
        minWidth: 148,
        borderRadius: 14,
        padding: theme.spacing(1.25, 3),
        backgroundColor: '#3C77D0',
        color: '#fff',
        fontWeight: 700,
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#2f64b4',
            boxShadow: 'none',
        },
        '&.Mui-disabled': {
            backgroundColor: '#c7d7f3',
            color: '#ffffff',
        },
    },
    confirmBlock: {
        marginTop: theme.spacing(2),
    },
    summaryRow: {
        marginBottom: theme.spacing(0.75),
    },
    footer: {
        backgroundColor: '#3C77D0',
        color: '#fff',
        '& a': {
            color: '#fff',
        },
    },
}));

const JwtRegister = (props) => {
    const history = useHistory();
    const classes = useStyles();

    const steps = [
        "Company Details",
        "Administrator Details",
        "Supporting Documents",
        "Confirmation",
    ];

    const [activeStep, setActiveStep] = useState(0);
    const [confirmChecked, setConfirmChecked] = useState(false);

    const [isSubmitSuccess, setSubmitSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data] = useState([]);
    const [snackBarState, setSnackBarState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        msg: '',
        severity: 'success'
    });

    const { isLoading, res, validation, error, urlId, sendRequest } = useHttp();

    const [inputData, setInputData] = useState({
        TMstAccnType: {
            atypId: "ACC_TYPE_RAEO_OPERATOR"
        }
    });
    const [validationErrors, setValidationErrors] = useState({});

    const handleInputChange = (e) => {
        setInputData({ ...inputData, [e.target.name]: e.target.value });
    };

    const handleDateChange = (name, e) => {
        setInputData({ ...inputData, [name]: e });
    };

    const handleInputChangeDeep = (name, value) => {
        setInputData({ ...inputData, ...deepUpdateState(inputData, name, value) });
    };

    const validateCurrentStep = () => {
        const errs = {};

        if (activeStep === 0) {
            if (!inputData.TMstAccnType?.atypId) errs.TMstAccnType = 'Account Type is required';
            if (!inputData.accnrCompReg) errs.accnrCompReg = 'TIN No. is required';
            if (!inputData.accnrTel) errs.accnrTel = 'Contact No is required';
            if (!inputData.accnrProv) errs.accnrProv = 'Province is required';
            if (!inputData.accnrCompName) errs.accnrCompName = 'Company Name is required';
            if (!inputData.accnrEmail) errs.accnrEmail = 'Company Email Address is required';
            if (!inputData.accnrAddressLine1) errs.accnrAddressLine1 = 'Address Line 1 is required';
            if (!inputData.accnrCity) errs.accnrCity = 'City / District is required';
            if (!inputData.TMstCountry?.ctyCode) errs.TMstCountry = 'Country is required';
        }

        if (activeStep === 1) {
            if (!inputData.accnrAplName) errs.accnrAplName = 'Full Name is required';
            if (!inputData.accnrAplTitle) errs.accnrAplTitle = 'Position is required';
            if (!inputData.accnrAplTel) errs.accnrAplTel = 'Contact No is required';
            if (!inputData.accnrAplPassNid) errs.accnrAplPassNid = 'ID / Passport No. is required';
            if (!inputData.accnrAplEmail) errs.accnrAplEmail = 'Email is required';
            if (!inputData.accnrAplAddr1) errs.accnrAplAddr1 = 'Address Line 1 is required';
            if (!inputData.accnrAplProv) errs.accnrAplProv = 'Province is required';
            if (!inputData.accnrAplCity) errs.accnrAplCity = 'City / District is required';
            if (!inputData.TMstCountryApl?.ctyCode) errs.TMstCountryApl = 'Country is required';
        }

        if (activeStep === 2) {
            const docs = inputData.accnDocs || [];
            const missing = docs.some(doc => !doc.attData && !doc.attName);
            if (missing) errs.accnDocs = 'Please upload all required documents';
        }

        setValidationErrors(errs);
        return Object.keys(errs).length === 0;
    };

    const handleNext = () => {
        if (activeStep === 3) {
            return;
        }

        if (!validateCurrentStep()) {
            return;
        }

        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
    };

    const handlePrevious = () => {
        setActiveStep((prev) => Math.max(prev - 1, 0));
    };

    const handleTabChange = (event, newValue) => {
        if (newValue <= activeStep) {
            setActiveStep(newValue);
            return;
        }

        if (validateCurrentStep()) {
            setActiveStep(newValue);
        }
    };

    const handleSubmit = async (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        setLoading(true);
        sendRequest("/sct/api/register/", "register", "post", inputData);
    };

    useEffect(() => {
        sendRequest("/sct/api/register/suppDocs", "loadSuppDocs", "get");
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!isLoading && !error && res && !validation) {
            switch (urlId) {
                case 'loadSuppDocs':
                    setInputData(prev => ({ ...prev, accnDocs: res.data }));
                    break;
                case 'register':
                    setSubmitSuccess(true);
                    setSnackBarState(sb => ({
                        ...sb,
                        open: true,
                        msg: "Registration submitted successfully, your application will be processed in 7 working days and you will receive an email notification once processed.",
                        severity: 'success'
                    }));
                    setLoading(false);
                    break;
                default:
                    break;
            }
        }

        if (error) {
            setLoading(false);
        }

        if (validation) {
            setSubmitSuccess(true);
            setSnackBarState(sb => ({
                ...sb,
                open: true,
                msg: 'Validation error',
                severity: 'error'
            }));
            setValidationErrors({ ...validation });
            setLoading(false);
        }
        // eslint-disable-next-line
    }, [isLoading, res, error, urlId, validation]);

    const handleClose = () => {
        setSnackBarState({ ...snackBarState, open: false });
        if (snackBarState.severity === 'success') {
            history.push('/session/signin');
        }
    };

    let snackBar = null;
    if (isSubmitSuccess) {
        const anchorOriginV = snackBarState.vertical;
        const anchorOriginH = snackBarState.horizontal;
        snackBar = (
            <Snackbar
                anchorOrigin={{ vertical: anchorOriginV, horizontal: anchorOriginH }}
                open={snackBarState.open}
                onClose={handleClose}
                autoHideDuration={null}
                key={anchorOriginV + anchorOriginH}
>
                <C1Alert
                    onClose={handleClose}
                    severity={snackBarState.severity}
                    action={
                        snackBarState.severity === 'success' && (
                            <Button
                                color="inherit"
                                size="small"
                                onClick={handleClose}
                            >
                                OK
                            </Button>
                        )
                    }
                >
                    {snackBarState.msg}
                </C1Alert>
            </Snackbar>
        );
    }

    return (
        <div className={classes.page}>
            {snackBar}

            <div className={clsx('relative w-full', classes.topBar)}>
                <div className="flex justify-between items-center h-full">
                    <div className="flex items-center h-full">
                        <img className="h-32" src={sctregLogo} alt="" />
                        <span className={clsx('font-medium text-24 mx-4', classes.brandText)}>EAC SCT</span>
                    </div>
                </div>
            </div>

            <main className={classes.main}>
                <Container disableGutters className={classes.formShell}>
                    <Paper className={classes.hero} elevation={0}>
                        <Typography variant="h5" className={classes.heroTitle}>
                            COMPANY REGISTRATION
                        </Typography>
                        <Typography variant="h6" className={classes.heroSubTitle}>
                            Complete the information below to create your company account and upload the required supporting documents.
                        </Typography>
                    </Paper>

                    <Card className={classes.tabsCard}>
                        <Tabs
                            value={activeStep}
                            onChange={handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            className={classes.tabsRoot}
                        >
                            <Tab label="1. Company" />
                            <Tab label="2. Administrator" />
                            <Tab label="3. Documents" />
                            <Tab label="4. Confirm" />
                        </Tabs>
                    </Card>

                    <Card className={classes.sectionCard}>
                        <div className={classes.sectionInner}>
                            {activeStep === 0 && (
                                <>
                                    <Typography className={classes.sectionEyebrow}>Section 1</Typography>
                                    <Typography variant="h5" className={classes.sectionTitle}>
                                        Company Details
                                    </Typography>
                                    <Typography className={classes.sectionDescription}>
                                        Use the legal business information exactly as it appears on your official registration and tax documents.
                                    </Typography>
                                    <TraderDetail
                                        handleSubmit={handleSubmit}
                                        data={data}
                                        inputData={inputData}
                                        props={props}
                                        handleInputChange={handleInputChange}
                                        handleDateChange={handleDateChange}
                                        handleInputChangeDeep={handleInputChangeDeep}
                                        errors={validationErrors}
                                        isDisabled={false}
                                        isSubmitting={loading}
                                    />
                                </>
                            )}

                            {activeStep === 1 && (
                                <>
                                    <Typography className={classes.sectionEyebrow}>Section 2</Typography>
                                    <Typography variant="h5" className={classes.sectionTitle}>
                                        Administrator Details
                                    </Typography>
                                    <Typography className={classes.sectionDescription}>
                                        Provide the primary administrator who will manage the account and receive official communication.
                                    </Typography>
                                    <UserDetail
                                        handleSubmit={handleSubmit}
                                        data={data}
                                        inputData={inputData}
                                        props={props}
                                        handleInputChange={handleInputChange}
                                        handleDateChange={handleDateChange}
                                        handleInputChangeDeep={handleInputChangeDeep}
                                        errors={validationErrors}
                                        isDisabled={false}
                                        isSubmitting={loading}
                                    />
                                </>
                            )}

                            {activeStep === 2 && (
                                <>
                                    <Typography className={classes.sectionEyebrow}>Section 3</Typography>
                                    <Typography variant="h5" className={classes.sectionTitle}>
                                        Supporting Documents
                                    </Typography>
                                    <Typography className={classes.sectionDescription}>
                                        Upload clear copies of the required documents. Accepted formats: PDF, JPG, JPEG, and PNG. Maximum file size: 10 MB per file.
                                    </Typography>
                                    <RegisterDocs
                                        inputData={inputData}
                                        isDisabled={false}
                                        errors={validationErrors}
                                    />
                                    {validationErrors.accnDocs && (
                                        <Typography color="error" style={{ marginTop: 12 }}>
                                            {validationErrors.accnDocs}
                                        </Typography>
                                    )}
                                </>
                            )}

                            {activeStep === 3 && (
                                <>
                                    <Typography className={classes.sectionEyebrow}>Section 4</Typography>
                                    <Typography variant="h5" className={classes.sectionTitle}>
                                        Confirmation
                                    </Typography>
                                    <Typography className={classes.sectionDescription}>
                                        Please review the information you entered and confirm that it is correct before submitting your registration.
                                    </Typography>

                                    <Divider />

                                    <Box className={classes.confirmBlock}>
                                        <Typography variant="subtitle1"><b>Company</b></Typography>
                                        <Typography className={classes.summaryRow}>
                                            Account Type: {inputData.TMstAccnType?.atypId === "ACC_TYPE_RAEO_OPERATOR" ? "Trader / Economic Operator" : (inputData.TMstAccnType?.atypId || "")}
                                        </Typography>
                                        <Typography className={classes.summaryRow}>
                                            Company Name: {inputData.accnrCompName || ""}
                                        </Typography>
                                        <Typography className={classes.summaryRow}>
                                            TIN No.: {inputData.accnrCompReg || ""}
                                        </Typography>
                                        <Typography className={classes.summaryRow}>
                                            Company Email Address: {inputData.accnrEmail || ""}
                                        </Typography>
                                        <Typography className={classes.summaryRow}>
                                            Contact No.: {inputData.accnrTel || ""}
                                        </Typography>
                                        <Typography className={classes.summaryRow}>
                                            Province: {inputData.accnrProv || ""}
                                        </Typography>
                                        <Typography className={classes.summaryRow}>
                                            City / District: {inputData.accnrCity || ""}
                                        </Typography>
                                    </Box>

                                    <Box className={classes.confirmBlock}>
                                        <Typography variant="subtitle1"><b>Administrator</b></Typography>
                                        <Typography className={classes.summaryRow}>
                                            Full Name: {inputData.accnrAplName || ""}
                                        </Typography>
                                        <Typography className={classes.summaryRow}>
                                            Position: {inputData.accnrAplTitle || ""}
                                        </Typography>
                                        <Typography className={classes.summaryRow}>
                                            ID / Passport No.: {inputData.accnrAplPassNid || ""}
                                        </Typography>
                                        <Typography className={classes.summaryRow}>
                                            Email: {inputData.accnrAplEmail || ""}
                                        </Typography>
                                        <Typography className={classes.summaryRow}>
                                            Contact No.: {inputData.accnrAplTel || ""}
                                        </Typography>
                                    </Box>

                                    <Box className={classes.confirmBlock}>
                                        <Typography variant="subtitle1"><b>Supporting Documents</b></Typography>
                                        {(inputData.accnDocs || []).length === 0 && (
                                            <Typography className={classes.summaryRow}>
                                                No document requirements loaded.
                                            </Typography>
                                        )}
                                        {(inputData.accnDocs || []).map((doc, idx) => (
                                            <Typography key={idx} className={classes.summaryRow}>
                                                {doc.attDesc || doc.docDesc || `Document ${idx + 1}`}: {doc.attName || "Not uploaded"}
                                            </Typography>
                                        ))}
                                    </Box>

                                    <Box className={classes.confirmBlock}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={confirmChecked}
                                                    onChange={(e) => setConfirmChecked(e.target.checked)}
                                                    color="primary"
                                                />
                                            }
                                            label="I confirm that the information and documents provided are true, complete, and correct."
                                        />
                                    </Box>
                                </>
                            )}
                        </div>
                    </Card>

                    <Card className={classes.actionsCard}>
                        <div className={classes.actionsInner}>
                            <Typography className={classes.actionsHint}>
                                {activeStep < 3
                                    ? "Complete this step, then continue to the next one."
                                    : "Please confirm correctness before submitting."}
                            </Typography>

                            <Box display="flex" gridGap={12}>
                                {activeStep > 0 && (
                                    <Button
                                        variant="contained"
                                        className={classes.navButton}
                                        onClick={handlePrevious}
                                    >
                                        {"<< Previous"}
                                    </Button>
                                )}

                                <Button
                                    variant="contained"
                                    className={classes.navButton}
                                    onClick={handleNext}
                                    disabled={activeStep === 3}
                                >
                                    {"Next >>"}
                                </Button>

                                {activeStep === 3 && (
                                    <Button
                                        variant="contained"
                                        className={classes.submitButton}
                                        onClick={handleSubmit}
                                        disabled={loading || isLoading || !confirmChecked}
                                    >
                                        Submit
                                    </Button>
                                )}
                            </Box>
                        </div>
                    </Card>
                </Container>
            </main>

            <AppBar position="static" className={classes.footer}>
                <Toolbar>
                    <span className="m-auto"></span>
                    <p className="m-0">
                        Developed and Powered by <a href="https: guud.company/" target="blank" rel="noreferrer">GUUD International</a>
                    </p>
                </Toolbar>
            </AppBar>
        </div>
    );
};

export default withErrorHandler(JwtRegister, axios);